// GENERATED by tools/module-icons/generate.py (ZEY-2419) — do not edit by hand.

export interface ModuleFamily { key: string; modules: string[]; }
export interface ModuleArt { family: string; menuUid: string; tint: string; glyph: string; }

/** Launchpad group order; a module's key is its TenantConfig Module.Key. */
export const MODULE_FAMILIES: ModuleFamily[] = [
  { key: 'insights', modules: ['dashboard', 'reporting'] },
  { key: 'finance', modules: ['accounting', 'treasury', 'budgets', 'assets'] },
  { key: 'commerce', modules: ['sales', 'pos', 'contacts'] },
  { key: 'supply', modules: ['purchasing', 'procurement', 'inventory', 'logistics'] },
  { key: 'production', modules: ['manufacturing', 'advanced-manufacturing', 'quality', 'printplates'] },
  { key: 'people', modules: ['hr', 'projects', 'approval-hub', 'chat'] },
  { key: 'platform', modules: ['integrations', 'configuration', 'admin', 'zeymoadmin'] },
];

/** Modules that have art under assets/icons/modules/. */
export const MODULE_ART: Record<string, ModuleArt> = {
  'dashboard': { family: 'insights', menuUid: 'dasboard', tint: '#E6F0FF', glyph: '#3183FD' },
  'reporting': { family: 'insights', menuUid: 'reporting', tint: '#E3EDFF', glyph: '#1368FC' },
  'accounting': { family: 'finance', menuUid: 'accounting', tint: '#E2F3E7', glyph: '#0C9C37' },
  'treasury': { family: 'finance', menuUid: 'treasury', tint: '#E2F2E2', glyph: '#0A950C' },
  'budgets': { family: 'finance', menuUid: 'budgets', tint: '#EAF2E1', glyph: '#529308' },
  'assets': { family: 'finance', menuUid: 'assets', tint: '#E2F1EB', glyph: '#0B8E56' },
  'sales': { family: 'commerce', menuUid: 'sales', tint: '#FFE7E7', glyph: '#FD3736' },
  'pos': { family: 'commerce', menuUid: 'PointOfSale', tint: '#FDE7E1', glyph: '#F03909' },
  'contacts': { family: 'commerce', menuUid: 'contacts', tint: '#FFE5E9', glyph: '#FF2347' },
  'purchasing': { family: 'supply', menuUid: 'purchasing', tint: '#E1F2F5', glyph: '#0993AA' },
  'procurement': { family: 'supply', menuUid: 'procurement', tint: '#E2F1F3', glyph: '#0C8C9E' },
  'inventory': { family: 'supply', menuUid: 'inventory', tint: '#E2F2F2', glyph: '#0D9293' },
  'logistics': { family: 'supply', menuUid: 'logistics', tint: '#E2F1F4', glyph: '#0B87A3' },
  'manufacturing': { family: 'production', menuUid: 'manufacturing', tint: '#FBECE1', glyph: '#DA6308' },
  'advanced-manufacturing': { family: 'production', menuUid: 'advanced-manufacturing', tint: '#FAECE1', glyph: '#D25D01' },
  'quality': { family: 'production', menuUid: 'quality', tint: '#F9EDE2', glyph: '#CC680A' },
  'printplates': { family: 'production', menuUid: 'printplates', tint: '#F8ECE1', glyph: '#C65E02' },
  'hr': { family: 'people', menuUid: 'human-resources', tint: '#F4ECFF', glyph: '#A762FD' },
  'projects': { family: 'people', menuUid: 'projects', tint: '#F2ECFF', glyph: '#9161FD' },
  'approval-hub': { family: 'people', menuUid: 'approval-hub', tint: '#F8E9FF', glyph: '#C146FD' },
  'chat': { family: 'people', menuUid: 'chat', tint: '#F2EBFF', glyph: '#9057FD' },
  'integrations': { family: 'platform', menuUid: 'integrations', tint: '#ECF1F7', glyph: '#6189BB' },
  'configuration': { family: 'platform', menuUid: 'configurations', tint: '#ECF0F5', glyph: '#6182AD' },
  'admin': { family: 'platform', menuUid: 'admin-panel', tint: '#EDF0F5', glyph: '#6885AC' },
  'zeymoadmin': { family: 'platform', menuUid: 'zeymoadmin', tint: '#ECF0F4', glyph: '#607EA3' },
};
